import { render, staticRenderFns } from "./downloadLinkDialogCard.vue?vue&type=template&id=77253cda"
import script from "./downloadLinkDialogCard.vue?vue&type=script&lang=ts"
export * from "./downloadLinkDialogCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports